import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {H1, H2} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {banner, bannerSubTitle, bannerTitle, description} from './referral-program.module.scss'

const Description = (): React.ReactElement => {
  const {t} = useSafeTranslation()

  return (
    <div className={description}>
      <H1 className={bannerTitle}>{t('REFERRAL_PROGRAM_BANNER_TITLE')}</H1>
      <H2 className={bannerSubTitle}>{t('REFERRAL_PROGRAM_BANNER_SUBTITLE')}</H2>
    </div>
  )
}

const CuteImage = (): React.ReactElement => {
  return (
    <Flex flexDirection="column" justifyContent="flex-end">
      <img src={`${PATHS.imageAssetsUrl}/teacher-dashboard/referral-program/elephants.svg`} />
    </Flex>
  )
}

const Banner = (): React.ReactElement => {
  return (
    <Flex className={banner}>
      <Description />
      <CuteImage />
    </Flex>
  )
}

export {Banner}
